import * as React from "react";
const SvgButtonReport = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 128 128",
	width: 128,
	height: 128,
	...props
}, /* @__PURE__ */ React.createElement("g", { transform: "matrix(5.333333333333333,0,0,5.333333333333333,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M12,18.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,18.75h0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 15.75L12 8.25",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeMiterlimit: 10,
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.621,1.76a1.806,1.806,0,0,0-3.242,0L.906,21.058A1.521,1.521,0,0,0,2.272,23.25H21.728a1.521,1.521,0,0,0,1.366-2.192Z",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
})));
export { SvgButtonReport as ReactComponent };
